import * as React from 'react'

import { NativeLink, Popover, QuestionIcon, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../common'
import { i18nKeyPrefix } from '../../i18n'

import { BodyContainer, QuestionIconContainer } from './QspPopover.styles'

const PRE = `${i18nKeyPrefix}-QSP-POPOVER`

export default function QspPopover() {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)

  return (
    <Popover body={<Body />} isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
      <QuestionIconContainer onClick={() => setIsOpen(true)}>
        <QuestionIcon />
      </QuestionIconContainer>
    </Popover>
  )
}

function Body() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <BodyContainer>
      <Text>{t(`${PRE}-TEXT`)}</Text>
      <NativeLink href="/quality-safety" target="_blank">
        {t(`${PRE}-LINK`)}
      </NativeLink>
      <Text>{t(`${PRE}-LEARN`)}</Text>
    </BodyContainer>
  )
}
